export default "__VITE_ASSET__DRj7h6hT__"